import { Reveal, Chapter } from "../../lib/motion";
import { LIFECYCLE } from "../../data";
import { Sprout, Recycle, TrendingDown, RefreshCw } from "lucide-react";

const HIGHLIGHTS = [
  { icon: Recycle, title: "Reduced Plastic Pollution", desc: "A direct replacement for single-use plastic and foam." },
  { icon: Sprout, title: "Renewable Resource", desc: "Made from sugarcane fibre that regrows every season." },
  { icon: TrendingDown, title: "Lower Carbon Footprint", desc: "Repurposes agricultural by-product instead of virgin plastic." },
  { icon: RefreshCw, title: "Circular Economy", desc: "From soil to table and back to soil — zero waste." },
];

export default function Sustainability() {
  return (
    <section id="sustainability" data-testid="sustainability" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Chapter number="05" overline="Sustainability" title="From sugarcane to soil — a closed natural loop." />

        <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-4 mb-20">
          {LIFECYCLE.map((s, i) => (
            <Reveal key={s.step} delay={0.06 * i}>
              <div className="relative h-full rounded-2xl bg-verra-base border border-verra-blue/10 p-6">
                <span className="font-display text-verra-light text-3xl">{s.step}</span>
                <h3 className="font-display text-xl text-verra-blue mt-2">{s.title}</h3>
                <p className="text-sm text-verra-blue/60 mt-2 leading-relaxed">{s.desc}</p>
                {i < LIFECYCLE.length - 1 && (
                  <span className="hidden lg:block absolute top-1/2 -right-2.5 text-verra-green">→</span>
                )}
              </div>
            </Reveal>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {HIGHLIGHTS.map((h, i) => (
            <Reveal key={h.title} delay={0.05 * i}>
              <div className="rounded-2xl bg-verra-green text-white p-7 h-full">
                <h.icon className="w-7 h-7 mb-4 text-verra-light" />
                <p className="font-display text-xl">{h.title}</p>
                <p className="text-white/70 text-sm mt-2 leading-relaxed">{h.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
